import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermContactCalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_contact_cal"}/>
}
